import { render, staticRenderFns } from "./SpoiledToggleButton.vue?vue&type=template&id=024d02a9&scoped=true&"
import script from "./SpoiledToggleButton.vue?vue&type=script&lang=js&"
export * from "./SpoiledToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d02a9",
  null
  
)

export default component.exports